/* ------------------------- External Dependencies -------------------------- */
/* ------------------------- Internal Dependencies -------------------------- */
/* ------------------------------- Component -------------------------------- */
export default props => null


// WEBPACK FOOTER //
// ./src/interface/containers/ethers/EthersInfuraConnect/component/index.js